<script lang="ts" setup>
    import { onMounted, reactive } from 'vue';
    import BSFormInputText from '@shared/components/BSFormInputText.vue';
    import InputRadio from '@shared/components/InputRadio.vue';
    import AddedContactLists from './AddedContactLists.vue';
    import AvailableContactLists from './AvailableContactLists.vue';
    import { loadLists } from '@views/Lists/Lists.access';
    import { List as ListsReference } from '@views/Lists/ListsTypes';
    import type { AddedLists, ListsProps } from './FormEditor.types';
    import Modal from '@shared/components/Modal.vue';

    const emit = defineEmits(['update:listsDisplay', 'update:listLegend']);

    const props = defineProps<ListsProps>();

    const state = reactive<{
        lists: AddedLists;
        accountLists: ListsReference[];
        showListModal: boolean;
    }>({
        lists: [],
        accountLists: [],
        showListModal: false,
    });

    const listsDisplayOptions = ['Hidden', 'Radio', 'Checkbox'];

    onMounted(async () => {
        state.accountLists = await loadLists();
        state.lists = props.lists;
    });

    /*
    $Resources.SubsciptionFormsListsHiddenLabel
    $Resources.SubsciptionFormsListsCheckboxLabel
    $Resources.SubsciptionFormsListsRadioLabel
    */
</script>

<script lang="ts"></script>

<template>
    <div class="form-group">
        <InputRadio
            v-for="listsDisplayOption in listsDisplayOptions"
            :checked="props.listsDisplay === listsDisplayOption.toLocaleLowerCase()"
            :value="listsDisplayOption.toLocaleLowerCase()"
            name="listsDisplay"
            @update:checked="(newVal) => $emit('update:listsDisplay', newVal)">
            <template #label>
                <span v-html="$Resources['SubsciptionFormsLists' + listsDisplayOption + 'Label']"></span>
            </template>
        </InputRadio>
    </div>

    <BSFormInputText
        v-show="props.listsDisplay !== 'hidden'"
        class="form-group"
        :modelValue="props.listsLegend"
        @update:modelValue="(newValue: string) => $emit('update:listLegend', newValue)"
        :label="$Resources.FormEditorFieldAddedLabelLabel"></BSFormInputText>

    <AddedContactLists :lists="state.lists" :accountLists="state.accountLists"></AddedContactLists>

    <div class="form-group">
        <button type="button" class="btn btn-default" :disabled="state.accountLists.length === 0" @click="state.showListModal = true">
            <span class="glyphicon glyphicon-plus m-xs-r" aria-hidden="true"></span>
            {{ $Resources.SubsciptionFormsChooseListsHeading }}
        </button>
    </div>

    <Modal size="lg" :title="$Resources.SubsciptionFormsChooseListsHeading" :show="state.showListModal" @close="state.showListModal = false">
        <template #content>
            <AvailableContactLists :accountLists="state.accountLists" :lists="state.lists"></AvailableContactLists>
        </template>
    </Modal>
</template>

<style></style>

<style scoped></style>
